export interface CategoryMeta {
  slug: string;
  name: string;
  en: string;
  desc: string;
  cover: string;
  tagline: string;
}

export const categories: CategoryMeta[] = [
  {
    slug: "yule",
    name: "娱乐圈",
    en: "Celebrities",
    desc: "影视、音乐、综艺圈的热点动态与幕后故事",
    tagline: "聚光灯下的台前幕后",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20red%20curtain%20stage%20spotlight%20backstage%20with%20film%20clapperboard%20and%20soft%20warm%20bokeh%20lights%2C%20editorial%20entertainment%20magazine%20mood%2C%20crimson%20and%20gold%20tones%2C%20artistic%20abstract&width=1200&height=500&seq=cat-yule-01&orientation=landscape",
  },
  {
    slug: "wanghong",
    name: "网红圈",
    en: "Influencers",
    desc: "直播、短视频、达人生态的最新动态与现象观察",
    tagline: "流量江湖里的人与事",
    cover: "https://readdy.ai/api/search-image?query=colorful%20neon%20city%20livestream%20studio%20with%20ring%20light%20and%20phone%20tripod%20silhouette%2C%20playful%20energetic%20social%20media%20vibe%2C%20warm%20amber%20and%20deep%20teal%20accents%2C%20editorial%20illustration&width=1200&height=500&seq=cat-wang-01&orientation=landscape",
  },
  {
    slug: "dujia",
    name: "独家首发",
    en: "Exclusive",
    desc: "第一手内幕与深度追踪，首发快人一步",
    tagline: "独家猛料第一现场",
    cover: "https://readdy.ai/api/search-image?query=breaking%20news%20newspaper%20layout%20with%20red%20stamp%20seal%20and%20document%20magnifier%20on%20desk%2C%20mysterious%20investigative%20journalism%20mood%2C%20crimson%20ink%20and%20cream%20paper%2C%20editorial%20flat%20lay&width=1200&height=500&seq=cat-duj-01&orientation=landscape",
  },
];

export interface NewsItem {
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  cover: string;
  summary: string;
  author: string;
  date: string;
  views: string;
  readMinutes: number;
  featured?: boolean;
  topHot?: boolean;
  tags: string[];
  body: string[];
}

export const articles: NewsItem[] = [
  {
    slug: "duanju-yanzhan-qushi",
    title: "短剧赛道厮杀升级，谁在闷声赚走第一桶金？",
    category: "wanghong",
    categoryName: "网红圈",
    cover: "https://readdy.ai/api/search-image?query=short%20drama%20production%20studio%20with%20smartphone%20screen%20showing%20video%20player%20and%20monitor%20wall%20behind%2C%20energetic%20creative%20team%20atmosphere%2C%20warm%20studio%20lighting%2C%20editorial%20feature&width=1200&height=720&seq=art-duanju-01&orientation=landscape",
    summary: "从单集几分钟到付费解锁，短剧这条快车道正吸引越来越多人入场。我们梳理了当下最热的分账模式与账号打法。",
    author: "爆姐编辑部",
    date: "2026-09-08",
    views: "23.6万",
    readMinutes: 6,
    featured: true,
    tags: ["短剧", "内容变现", "行业观察"],
    body: [
      "过去一年，短剧这条赛道从野蛮生长进入精耕细作的阶段。曾经靠'反转+爽感'就能跑量的套路逐渐失效，取而代之的是对剧本节奏、情绪钩子与付费时点的精细打磨。本期我们从制作端到分发端，拆解这门生意究竟怎么运转。",
      "在不少从业者看来，短剧的核心从来不是'时长更短'，而是'密度更高'。用户在几秒内能否被抓住、第一集结尾能否让人忍不住点下一集，几乎决定了整部剧的生死。为此，编剧会把情绪冲突前置，把信息量压缩到每一帧。",
      "变现侧的玩法也在快速迭代。除了传统广告植入，小程序付费、品牌定制剧与端内会员正在成为新增长点。一位内容机构负责人坦言，真正赚钱的往往是那些把数据跑通、再把方法论复制到下一部的团队，而不是单点爆款的运气。",
      "当然，热钱涌入也带来隐忧：同质化加剧、演员与剧本被快速消耗。我们认为，短剧的下半场比拼的将是谁能建立稳定的内容供应链，谁能在爽感之外提供一点点'留得住人'的质感。",
    ],
  },
  {
    slug: "honghu-dongzuopian-tuxin",
    title: "暑期档爆款背后：一部动作片的工业与耐心",
    category: "yule",
    categoryName: "娱乐圈",
    cover: "https://readdy.ai/api/search-image?query=blockbuster%20action%20movie%20set%20with%20cinema%20camera%20rig%20and%20green%20screen%20studio%2C%20dramatic%20orange%20and%20crimson%20lighting%2C%20epic%20film%20production%20mood%2C%20editorial&width=1200&height=720&seq=art-honghu-01&orientation=landscape",
    summary: "一部暑期档动作片的口碑逆袭，背后是服化道、动作设计与现场调度的层层较劲。我们和主创聊了聊那些看不见的细节。",
    author: "小露在现场",
    date: "2026-09-06",
    views: "18.2万",
    readMinutes: 8,
    featured: true,
    topHot: true,
    tags: ["影视", "幕后", "工业流程"],
    body: [
      "说起今年暑期档，绕不开的自然是那部票房一路走高的动作片。银幕上拳拳到肉的三分钟，背后可能是整个团队近一个月的反复排练与实拍。这次我们走进剧组，聊聊工业化拍摄背后那些容易被忽略的环节。",
      "在动作指导看来，好的打戏不是靠数量堆出来的，而是靠'设计感'。每一个过招都要服务于人物情绪和叙事推进，纯粹的炫技反而会让观众出戏。为此，武术组会和美术、摄影提前磨合走位，把镜头语言写进动作脚本。",
      "服化道同样是隐藏的功臣。演员身上的做旧、伤疤乃至汗渍，都在为角色的可信度加分。美术指导说，观众或许说不出哪里好，但一定会感觉到'真实'，这种直觉正是大量现场细节累积的结果。",
      "从立项到上映，这部影片走过了漫长的三年。行业常说'慢工出细活'，而在追求效率的时代里，愿意为一帧画面较真的人，反而更容易赢得观众的耐心与掌声。",
    ],
  },
  {
    slug: "zhibo-dianshang-yulehua",
    title: "直播电商进入'泛娱乐'时代，叫卖之外还能讲什么？",
    category: "wanghong",
    categoryName: "网红圈",
    cover: "https://readdy.ai/api/search-image?query=modern%20ecommerce%20livestream%20host%20with%20headset%20in%20bright%20product%20studio%2C%20colorful%20merchandise%20shelves%20and%20softbox%20lights%2C%20fresh%20energetic%20atmosphere%2C%20editorial&width=1200&height=720&seq=art-zhibo-01&orientation=landscape",
    summary: "当'全网最低价'不再是唯一卖点，直播间的叙事方式正在被重新书写。从情景剧到综艺化，主播们的下一步在哪里？",
    author: "流量观察站",
    date: "2026-09-04",
    views: "12.7万",
    readMinutes: 5,
    tags: ["直播", "电商", "达人生态"],
    body: [
      "如果你最近常逛直播间，不难发现一个变化：光靠喊口号和压价格的年代正在过去。越来越多主播开始把选品讲成故事，把下单变成一场互动，直播间越来越像一档随时在播的综艺。",
      "这种'泛娱乐化'转向的背后，是用户注意力的争夺。当低价带来的刺激边际递减，能留住人的反而是情绪价值和陪伴感。品牌也开始意识到，直播间不仅是货架，更是内容现场。",
      "当然，娱乐化并不意味着脱离货的本质。业内人士提醒，一切花活最终都要回到产品质量与售后体验上，否则再热闹的场面也只是一次性消费。",
      "可以预见，未来直播间的竞争将从'谁的嗓门大'转向'谁的团队更会做内容'。这也是我们对达人生态持续保持好奇的原因所在。",
    ],
  },
  {
    slug: "yulegongshi-xinmima-xianxiang",
    title: "从'人设'到'人格'：明星IP运营的下一个分水岭",
    category: "yule",
    categoryName: "娱乐圈",
    cover: "https://readdy.ai/api/search-image?query=celebrity%20portrait%20silhouette%20under%20soft%20key%20light%20with%20shadow%20play%20on%20wall%2C%20thoughtful%20identity%20and%20brand%20concept%2C%20warm%20monochrome%20gold%20tone%2C%20editorial&width=1200&height=720&seq=art-renge-01&orientation=landscape",
    summary: "当粉丝越来越'懂行'，明星与受众之间单纯的仰望关系正在松动。IP运营者们开始把'真实感'当作新的护城河。",
    author: "编辑部深度",
    date: "2026-09-02",
    views: "15.4万",
    readMinutes: 7,
    topHot: true,
    tags: ["明星IP", "粉丝文化", "营销"],
    body: [
      "'塌房'这个词流行之后，行业里最焦虑的恐怕就是各类IP操盘手。过去，一个精心打造的人设就能撑起商业价值；如今，稍有裂缝便会引发连锁反应。大家逐渐明白：人设的边际收益正在走低。",
      "于是，'真实感'成了新的关键词。越来越多的艺人团队选择在保持边界的前提下适度袒露日常，把脆弱、困惑乃至成长讲给粉丝听。相比完美无缺的神坛形象，可亲近的人格往往更能建立长期的信任连接。",
      "不过，真实并不意味着全盘袒露。成熟的IP运营更像一门'减法艺术'——哪些可以分享，哪些必须守护，都需要清晰的判断。过度曝光与刻意人设一样，都可能反噬价值。",
      "归根结底，明星与受众的关系正从'仰望'走向'同行'。谁能在专业作品之外提供稳定、真诚的人格支撑，谁就更有机会穿越周期。",
    ],
  },
  {
    slug: "zongyi-huanxin-nanti",
    title: "综艺如何留住'挑剔'的年轻观众？",
    category: "yule",
    categoryName: "娱乐圈",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20variety%20show%20stage%20with%20confetti%20and%20round%20sofa%20set%2C%20playful%20warm%20lights%20and%20colorful%20props%2C%20energetic%20tv%20entertainment%20mood%2C%20editorial&width=1200&height=720&seq=art-zongyi-01&orientation=landscape",
    summary: "老牌综艺续命、新综艺出圈，观众用遥控器投票的时代里，一档节目要如何定义自己的'不可替代'？",
    author: "综艺观察",
    date: "2026-08-30",
    views: "9.8万",
    readMinutes: 6,
    tags: ["综艺", "内容趋势"],
    body: [
      "屏幕前的观众正在变得越来越'挑剔'——他们能一眼识破剧本，也能为真诚的瞬间买单。在这样的环境里，一档综艺若想留住人，单靠明星阵容和花哨剪辑远远不够。",
      "梳理今年出圈的作品不难发现，共性在于'人'被真正放大了。无论是老友重逢的情感浓度，还是素人选手的意外闪光，都让观众找到了可代入的坐标。所谓共情，恰恰是综艺最稀缺也最值钱的东西。",
      "另一方面，形式创新仍在继续。露营、旅行、慢生活等场景化表达，让节目从演播室走向更开阔的空间，也在无形中降低了'观看疲劳'。",
      "当然，情怀与创新需要平衡。过度消费旧回忆会带来审美透支，而为了新而新的冒险又容易失焦。能把控好这份张力，才是节目组真正的功课。",
    ],
  },
  {
    slug: "wanghong-dianxing-gongsi-yinying",
    title: "红人背后的公司：一场关于签约与解约的博弈",
    category: "wanghong",
    categoryName: "网红圈",
    cover: "https://readdy.ai/api/search-image?query=stack%20of%20contract%20documents%20with%20pen%20and%20reading%20glasses%20on%20desk%20under%20warm%20desk%20lamp%2C%20business%20negotiation%20atmosphere%2C%20deep%20crimson%20and%20cream%20tones%2C%20editorial&width=1200&height=720&seq=art-hetong-01&orientation=landscape",
    summary: "合作共赢还是条款陷阱？红人与经纪公司之间的契约关系，往往比镜头前的光鲜复杂得多。",
    author: "深度追踪组",
    date: "2026-08-28",
    views: "11.3万",
    readMinutes: 6,
    tags: ["红人经济", "法律", "行业观察"],
    body: [
      "镜头前光鲜亮丽的红人，镜头后往往要面对一纸复杂的经纪合约。签约时承诺的资源扶持、解约时要付出的代价，这些藏在细节里的条款，正成为红人圈最敏感的议题之一。",
      "在业内人士看来，健康的合作应当是'双向奔赴'——机构提供供应链、投放与商务资源，红人贡献内容与粉丝号召力。但现实是，信息不对称常常让刚起步的新人处于弱势。",
      "我们观察到，越来越多的成熟红人开始设立个人工作室，或聘请独立的法务顾问审阅合同。相比一味对抗，把权责厘清、让收益透明，正在成为行业的共同诉求。",
      "说到底，红人经济要行稳致远，离不开制度的完善与从业者意识的觉醒。只有把游戏规则讲清楚，这个行业才能留住更多愿意长期投入的人。",
    ],
  },
  {
    slug: "dujia-pingjing-lvshi-feiwen",
    title: "独家：那些'没有热搜'的爆款，是怎么悄悄火起来的",
    category: "dujia",
    categoryName: "独家首发",
    cover: "https://readdy.ai/api/search-image?query=viral%20content%20on%20smartphone%20screen%20held%20by%20hand%20with%20glowing%20social%20app%20icons%20and%20dark%20room%20background%2C%20mysterious%20and%20curious%20atmosphere%2C%20warm%20glow%2C%20editorial&width=1200&height=720&seq=art-feiwen-01&orientation=landscape",
    summary: "热搜是结果不是原因。我们采访了多位'幕后推手'，还原那些没花一分钱上榜的爆款，究竟赢在哪一步。",
    author: "独家调查组",
    date: "2026-08-26",
    views: "26.9万",
    readMinutes: 8,
    featured: true,
    topHot: true,
    tags: ["独家", "爆款拆解", "传播"],
    body: [
      "在不少人眼里，火起来似乎等于上了热搜。但真实的传播逻辑往往相反：热搜只是结果，真正让内容火起来的，是发布前那套几乎看不见的编排。这期独家，我们试图还原一条爆款的完整路径。",
      "多位操盘手提到一个共同的词——'时机'。内容的传播窗口往往转瞬即逝，同一个段子，早了没人接得住，晚了就跟不上热点。所谓爆款直觉，说到底是对人群情绪曲线的敏感。",
      "除了时机，'钩子密度'同样关键。首屏的封面、前五秒的台词、结尾的互动引导，每一处都在为'转发'设计。那些看似随意的文案，其实是反复测试后的最优解。",
      "值得注意的是，真正的长尾爆款往往源于真诚而非套路。当创作者开始提供超出预期的价值，算法与口碑自会把它推得更远。这也是我们判断'下一匹黑马'的重要线索。",
    ],
  },
  {
    slug: "dujia-yulegongsi-neibuguankong",
    title: "独家走访：一份爆款剧集的'数据复盘'能有多细",
    category: "dujia",
    categoryName: "独家首发",
    cover: "https://readdy.ai/api/search-image?query=data%20dashboard%20on%20multiple%20monitors%20in%20dark%20content%20operation%20room%20with%20charts%20and%20viewership%20curves%2C%20focused%20analyst%20mood%2C%20deep%20blue%20and%20amber%20tones%2C%20editorial&width=1200&height=720&seq=art-fupan-01&orientation=landscape",
    summary: "剧集播出后不是终点，而是另一场精细运营的起点。我们潜入制作方后台，看一帧画面如何被数据反复校准。",
    author: "编辑部调查",
    date: "2026-08-23",
    views: "14.1万",
    readMinutes: 7,
    tags: ["独家", "数据", "影视运营"],
    body: [
      "一部剧集播完，运营工作却远未结束。在制作方后台，我们看到的是按分钟拆解的用户留存曲线、按角色统计的讨论热词，甚至某一帧弹幕的密集程度。数据复盘，正在成为爆款的标配动作。",
      "受访的数据团队表示，复盘的目的不是事后追责，而是为下一部作品建立'肌肉记忆'。哪些情节点让观众留下，哪些转折导致流失，都会被量化成下一次创作时的参考坐标。",
      "当然，数据也有边界。过于依赖模板化的'爆款公式'，反而容易让作品趋同。真正的高手，是让数据服务于创作直觉，而非反过来被数据牵着走。",
      "在我们看来，这份对细节的较真，或许正是国产内容持续进步的可贵注脚。工业化的终点，永远是更好地讲人的故事。",
    ],
  },
  {
    slug: "wanghong-xingye-youyige-changwei",
    title: "主播连麦翻车之后，平台与达人都在补什么课？",
    category: "wanghong",
    categoryName: "网红圈",
    cover: "https://readdy.ai/api/search-image?query=two%20people%20talking%20through%20phone%20video%20call%20on%20split%20screens%2C%20serious%20discussion%20conversation%20about%20content%20review%2C%20cool%20and%20warm%20duotone%2C%20editorial&width=1200&height=720&seq=art-lianmai-01&orientation=landscape",
    summary: "一次直播事故引发的行业反思：当内容把关跟不上流量速度，平台与达人如何重建信任？",
    author: "舆论场观察",
    date: "2026-08-20",
    views: "10.5万",
    readMinutes: 5,
    tags: ["直播", "平台治理"],
    body: [
      "直播是即时的艺术，也是风险的艺术。一次连麦事故、一句失当言论，都可能在几秒内造成难以挽回的连锁反应。近期行业里关于'内容把关'的讨论，正是对这种风险的集中反思。",
      "对平台而言，审核机制的升级只是基础。更关键的是如何在鼓励创作与守住底线之间找到动态平衡，避免'一刀切'伤了内容生态的活力。",
      "对达人而言，专业与自觉同样重要。越来越多头部主播开始配备内容审核团队，对脚本、言论与连麦对象进行前置评估，把风险消灭在开播之前。",
      "我们相信，短期的事故总会过去，但由事故催生的制度进步，才是行业真正收获的财富。",
    ],
  },
  {
    slug: "yingxiao-shoudu-1960s",
    title: "复古风吹回舞台：当复古美学成为新的流量密码",
    category: "yule",
    categoryName: "娱乐圈",
    cover: "https://readdy.ai/api/search-image?query=retro%201960s%20cinema%20set%20with%20vintage%20vinyl%20record%20and%20film%20projector%20warm%20amber%20glow%2C%20nostalgic%20golden%20age%20aesthetic%2C%20editorial%20editorial&width=1200&height=720&seq=art-fugu-01&orientation=landscape",
    summary: "从复古穿搭到港风金曲，怀旧正在以各种形式回归。这波复古潮流，究竟撩动了谁的心弦？",
    author: "风尚观察",
    date: "2026-08-18",
    views: "8.6万",
    readMinutes: 5,
    tags: ["复古", "文化", "潮流"],
    body: [
      "最近，复古二字几乎成了内容场的万能密码。复古穿搭、港风造型、千禧滤镜轮番刷屏，连带老歌翻唱和年代剧也重新翻红。怀旧，正在变成一门备受青睐的生意。",
      "在心理层面，复古提供了一种确定的归属感。面对节奏飞快的变化，人们反而更愿意从熟悉的符号里寻找安心。对创作者来说，复古既降低了理解门槛，又自带情绪基础，天然适合二次创作。",
      "不过，单纯的复刻难以长久。真正能立住脚的，往往是在旧元素里注入新表达——比如用现代的制作逻辑重新演绎一首老歌，或用当下的视角讲述过去的故事。",
      "潮流总在轮回，但每一次轮回都不会完全相同。留住旧日温度、接上新鲜呼吸，或许才是复古美学真正的生命力。",
    ],
  },
  {
    slug: "yule-paiwang-yanshengxueyuan",
    title: "新人演员的出道战：试镜、经纪与'第一次被看见'",
    category: "yule",
    categoryName: "娱乐圈",
    cover: "https://readdy.ai/api/search-image?query=young%20actor%20backstage%20by%20mirror%20before%20audition%20with%20soft%20warm%20bulbs%2C%20hopeful%20aspiring%20atmosphere%2C%20cinematic%20golden%20tone%2C%20editorial&width=1200&height=720&seq=art-xinren-01&orientation=landscape",
    summary: "对怀揣演员梦的年轻人来说，第一次站在镜头前意味着什么？一场关于等待、试错与坚持的漫长练习。",
    author: "新人说栏目",
    date: "2026-08-15",
    views: "7.2万",
    readMinutes: 6,
    tags: ["新人", "成长", "行业纪实"],
    body: [
      "每个光鲜的出道故事背后，几乎都藏着一段漫长的等待。新人演员的日常，常常是在一个又一个试镜现场奔波，在'被选择'与'被拒绝'之间反复横跳。",
      "对很多新人而言，第一关其实是心态。一场试镜可能只有几分钟，却要浓缩数年的训练与准备。面试官的一句话、一个眼神，都可能改变接下来的走向。",
      "经纪团队的作用同样不可小觑。靠谱的团队不只安排通告，更会在角色选择与形象规划上给出长远建议，帮新人少走弯路。而这一切的前提，是双向的信任与耐心。",
      "我们始终觉得，行业需要更多给新人机会的舞台。因为每一束此刻的微光，都可能是未来某个时代的序章。",
    ],
  },
  {
    slug: "dujia-neimu-zhengzhu-pingtai",
    title: "独家内幕：内容平台的'推荐算法'如何影响你刷到什么",
    category: "dujia",
    categoryName: "独家首发",
    cover: "https://readdy.ai/api/search-image?query=abstract%20neural%20network%20and%20feed%20algorithm%20visualization%20with%20glowing%20nodes%20connecting%20to%20content%20cards%2C%20mysterious%20digital%20technology%20mood%2C%20crimson%20and%20deep%20navy%2C%20editorial&width=1200&height=720&seq=art-suanfa-01&orientation=landscape",
    summary: "你刷到的每一条内容，背后都有一套算法逻辑。我们拆解推荐机制如何塑造你的信息世界。",
    author: "科技内幕组",
    date: "2026-08-12",
    views: "19.7万",
    readMinutes: 8,
    topHot: true,
    tags: ["独家", "算法", "平台"],
    body: [
      "每天滑动的手指，其实正在被一套精密的算法牵引。推荐系统会记录你的停留、点赞与转发，并据此推测你下一次更想看什么。这期独家，我们把镜头对准了这套看不见的'编辑'。",
      "算法并不神秘，它的核心是'匹配'——把合适的内容在合适的时机推给合适的人。创作者为了被看见，会研究标签、时长的分布，也会顺应节奏优化标题与封面，让内容更贴合算法的偏好。",
      "但算法也有其局限。过度依赖用户过往行为，容易让人陷入'信息茧房'，同类内容不断强化，视野却越来越窄。这也是平台近年来努力引入更多'探索'机制的原因。",
      "对我们普通用户而言，理解算法不是为了对抗它，而是为了更清醒地使用它。多元的兴趣、主动的搜索，往往能让信息流变得更有营养。",
    ],
  },
];

export const getArticlesByCategory = (slug: string) =>
  articles.filter((a) => a.category === slug);

export const getArticleBySlug = (slug: string) =>
  articles.find((a) => a.slug === slug);

export const getCategoryBySlug = (slug: string) =>
  categories.find((c) => c.slug === slug);

export const hotList = [...articles]
  .sort((a, b) => Number(b.views.replace("万", "")) - Number(a.views.replace("万", "")))
  .slice(0, 6);

export const latestList = [...articles].sort((a, b) =>
  b.date.localeCompare(a.date),
);

export const featuredArticles = articles.filter((a) => a.featured);
export const topHotArticles = articles.filter((a) => a.topHot);